export const PersonHasLoanedEquipment = "person_has_loaned_equipment";
export const PersonHasMultipleMissions = "person_multiple_missions";
export const MissionInGroup = "mission_in_group";
